import React from 'react';
import { getProductImageUrl } from '../../../utils/productHelpers';
import { formatCurrency } from '../../../utils/formatters';
import { getVariantText, getRentalPeriod, getItemPrice } from '../utils/orderSummaryUtils';

const MerchantItemsList = ({ groupedItems }) => {
  return (
    <>
      {Object.entries(groupedItems).map(([merchantId, group]) => (
        <div key={merchantId} className="mb-6">
          <h3 className="font-medium text-gray-600 mb-3">
            {group.name}
          </h3>
          
          <div className="space-y-4">
            {group.items.map((item, index) => {
              // Determine item's currency
              const itemCurrency = item.currency || 
                (item.rentalPeriod?.currency) || 
                (item.rentPriceAndTime && item.rentPriceAndTime.length > 0 ? 
                  item.rentPriceAndTime[0].currency : 'USD');
              
              // Determine if item is shippable
              const isShippable = !item.isUnshippable;
                  
              return (
                <div key={index} className={`flex items-start ${isShippable ? '' : 'opacity-50'}`}>
                  <div className="h-16 w-16 flex-shrink-0 overflow-hidden rounded-md mr-4">
                    <img
                      src={getProductImageUrl(item)}
                      alt={item.name || item.product?.name}
                      className="h-full w-full object-cover object-center"
                    />
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-gray-900">{item.name || item.product?.name}</p>
                    <p className="mt-1 text-xs text-gray-500">
                      {getVariantText(item)}
                      {getVariantText(item) && ' · '}
                      Qty {item.quantity}
                    </p>
                    {/* {!isShippable && (
                      <p className="mt-1 text-xs text-red-500">
                        Not available for shipping to this address
                      </p>
                    )} */}
                    {item.type === 'rent' && (
                      <p className="mt-1 text-xs text-gray-500">
                        {getRentalPeriod(item)}
                      </p>
                    )}
                  </div>
                  <p className={`text-sm font-medium ${isShippable ? 'text-gray-900' : 'text-gray-400'}`}>
                    {formatCurrency(getItemPrice(item), itemCurrency)}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </>
  );
};

export default MerchantItemsList; 